module.exports = {
  something_wrong: "Quelque chose s'est mal passé.",
  new_package: "Nouveau Colis",
  update_package: "Modifier le Colis",
}
